import { render, staticRenderFns } from "./ProductRecap.vue?vue&type=template&id=5d546266"
import script from "./ProductRecap.vue?vue&type=script&lang=js"
export * from "./ProductRecap.vue?vue&type=script&lang=js"
import style0 from "./ProductRecap.vue?vue&type=style&index=0&id=5d546266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports